import React, { useEffect, useState } from 'react'

interface UISwitchProps {
  value: boolean
  onValueChange: (value: boolean) => void
}

const UISwitch: React.FC<UISwitchProps> = ({ value, onValueChange }) => {
  const [isOn, setIsOn] = useState<boolean>(value)
  useEffect(() => {
    setIsOn(value)
  }, [value])

  const toggleSwitch = () => {
    const newValue = !isOn
    setIsOn(newValue)
    onValueChange(newValue)
  }

  return (
    <div className="relative">
      <button
        className={`w-10 h-6 rounded-full ${
          isOn ? 'bg-[#01B38B]' : 'bg-gray3'
        } focus:outline-none`}
        onClick={toggleSwitch}
      >
        <div
          className={`absolute inset-y-0 left-0 w-5 h-5  m-[2px] bg-text8 rounded-full shadow-md transition-transform duration-300 transform ${
            isOn ? 'translate-x-full ml-[-2px]' : 'translate-x-0'
          }`}
        ></div>
      </button>
    </div>
  )
}

export default UISwitch
